import { useQuery } from '@tanstack/react-query';

import { PermissionResponse } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

type QueryFnType = typeof queryFn;

const RESOURCE = '/users/user/permissions/';

const queryFn = (): Promise<PermissionResponse> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(),
        ...config,
    });
};

export { useQueryHook as useGetPermissions, RESOURCE as GET_PERMISSIONS_RESOURCE };
